// extracted by mini-css-extract-plugin
export default {"videos":"Videos_videos__M-FNn","title":"Videos_title__dsu4J","video":"Videos_video__Q4F3N"};